import { render, staticRenderFns } from "./CreateNote.vue?vue&type=template&id=4f8f16ed"
import script from "./CreateNote.vue?vue&type=script&lang=ts"
export * from "./CreateNote.vue?vue&type=script&lang=ts"
import style0 from "./CreateNote.vue?vue&type=style&index=0&id=4f8f16ed&prod&lang=sass"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports